const RequestType = `
  id
  name
`;

export default RequestType;
